
export function bodyClass(name) {
    document.body.className = name;
}
